import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function biharMuzaffarpurPlant() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content">
                        <h2>
                          Orissa Drugs & Chemicals Ltd. (ODCL). Bhubaneswar
                        </h2>

                        <div class="row">
                          <div class="col-sm-6">
                            <img
                              src="../images/BhubaneswarPlant.jpg"
                              class="img-responsive"
                            />
                          </div>
                          {/* <div class="col-sm-6">
                            <div class="address">
                              <ul>
                                <li>
                                  <img src="../images/person.png" />{" "}
                                  <span>Contact Person Name : </span>Shri
                                  Prafulla Kumar Swain
                                </li>
                                <li>
                                  <img src="../images/desi.png" />{" "}
                                  <span>Designation : </span> General Manager
                                  In-charge
                                </li>
                                <li>
                                  <img src="../images/home-icon.png" />{" "}
                                  <span>Address : </span> Orissa Drugs and
                                  Chemicals Ltd., Mancheswar Industrial Estate,
                                  Bhubaneshwar – 751010
                                </li>
                                <li>
                                  <img src="../images/cell_icon.gif" />{" "}
                                  <span>Telephone : </span> 0674-2580250
                                </li>
                                <li>
                                  {" "}
                                  <img src="../images/fax.png" />
                                  <span> Fax No. : </span>0674 -2580250
                                </li>
                                <li>
                                  <img src="../images/mouse_icon.gif" />{" "}
                                  <span>E-mail : </span>
                                  odcl.bbsr.govt@gmail.com
                                </li>
                              </ul>
                            </div>
                          </div> */}
                          <div class="col-sm-6">
                            <p className="mt-2">
                              Orissa Drugs & Chemicals Ltd. (ODCL). Bhubaneswar was
                              set-up as joint sector unit with Government of Orissa
                              in May, 1979 with authorized capital of Rs. 160.00
                              lakhs and paid-up capital of Rs. 132.15 lakhs.
                            </p>
                            <p>
                              The Share if IDPL in the paid-up capital is 51% and
                              that of Industrial Promotion & Investment Corporation
                              of Orissa Ltd. (IPICOl ) is 49%.
                            </p>
                            <p>
                            It has a large production capacity to manufacture
                          Acetaldehyde (7500 metric tonnes), Acetic Acid (4500
                          metric tonnes), Methyl Ethyl Pyridine (1200 metric
                          tonnes), Niacin (500 metric tonnes and Niacinamide
                          (300 metric tonnes).
                            </p>
                          </div>
                        </div>
                        <br />


                        <p>
                          The production process is highly
                          automatic and continuous for Acetaldehyde and Acetic
                          Acid coupled with equipments to avoid any pollution.
                          It also has facilities for treating effluents
                          generated in batch processes of Niacin and
                          Niacinamide.
                        </p>
                        <p>
                          Pursuant to Order of Hon'ble High Court of Orissa,
                          Cuttack, dated 23.06.2023, Orissa Drugs & Chemicals
                          Limited (ODCL), a Joint Venture of IDPL & IPICOL (A
                          Govt. of Orissa undertaking) is now under Liquidation.
                          Henceforth, all claims & communications with respect
                          to ODCL may please be directed to the Official
                          Liquidator i.e. Registrar of Companies (ROC) Cuttack.
                        </p>
                        <br />

                        <div class="clearfix"></div>

                        <div class="">
                          <iframe
                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14966.884804840853!2d85.8491239!3d20.311804!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc0f8a3912494208f!2sOrissa+Drugs+%26+Chemicals+Limited!5e0!3m2!1sen!2sin!4v1450351806790"
                            width="100%"
                            height="250"
                            frameborder="0"
                            style={{ border: "0;" }}
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
